// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@eisinc/App/SharedStyles/CartLineSharedStyles";
import { cartLineQuantityStyles } from "@eisinc/Overrides/Widgets/Cart/CartLineQuantity";
import { xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

cartLineQuantityStyles.editableQuantityTextField = {
    labelProps: {
        forwardAs: "legend",
        css: css`
            display: none;
            ${xScreen("lte", "md")} {
                display: block;
            }
            @media print {
                display: block;
            }
        `,
    },
};

cartLineQuantityStyles.readOnlyQuantityText = {
    heading: {
        ...cartLineSharedStyles.qtyLabel,
    },
    text: {
        ...cartLineSharedStyles.qtyValue,
    },
};
